import { Stack } from '@koob/margaret';
import { KoobTooltip } from '@koob/ui';
import { FormLabel } from 'ui';
import SelectCurrencyField from './SelectCurrencyField';

export const CurrencyField = ({
  label,
  disabled = false,
  required = false,
  tip,
}) => {
  return (
    <div className="flex-none">
      <Stack direction="row" gutterSize={0.25}>
        {label && (
          <FormLabel>
            {label}
            {required && !disabled && (
              <span className="ml-1 text-red-500">*</span>
            )}
          </FormLabel>
        )}

        {disabled && (
          <KoobTooltip
            tip={<span className="whitespace-pre-line">{tip}</span>}
            position="top"
          >
            <i className="fa-regular fa-circle-info" />
          </KoobTooltip>
        )}
      </Stack>

      <SelectCurrencyField
        name="currency"
        valueField="value"
        required
        disabled={disabled}
      />
    </div>
  );
};
